export const formatCurrency = new Intl.NumberFormat('en-us', {
  // notation: 'compact',
  maximumSignificantDigits: 12
});
